import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { ClipboardCheck, Calendar, TrendingUp, FileText, Image as ImageIcon, Video, CheckCircle } from 'lucide-react';

const MeasurementSection = ({ toolkit }) => {
  const metrics = toolkit.measurement.requiredMetrics;
  const checklist = toolkit.measurement.qualityChecklist;
  
  return (
    <div className="space-y-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center">
          <ClipboardCheck className="w-6 h-6 text-teal-700" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Measurement Checklist</h2>
          <p className="text-gray-600">Weekly targets and quality standards</p>
        </div>
      </div>

      <Card className="border-2 border-green-200 bg-gradient-to-br from-green-50 to-white">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Calendar className="w-5 h-5 text-green-700" />
            Weekly Submission Targets
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-3 gap-4">
            <div className="text-center p-6 bg-white rounded-xl border-2 border-green-300">
              <FileText className="w-10 h-10 text-green-600 mx-auto mb-3" />
              <p className="text-4xl font-bold text-green-800">{toolkit.measurement.weeklyTargets.stories}</p>
              <p className="text-sm text-gray-600">Stories</p>
            </div>
            <div className="text-center p-6 bg-white rounded-xl border-2 border-blue-300">
              <ImageIcon className="w-10 h-10 text-blue-600 mx-auto mb-3" />
              <p className="text-4xl font-bold text-blue-800">{toolkit.measurement.weeklyTargets.photos}</p>
              <p className="text-sm text-gray-600">Photos</p>
            </div>
            <div className="text-center p-6 bg-white rounded-xl border-2 border-purple-300">
              <Video className="w-10 h-10 text-purple-600 mx-auto mb-3" />
              <p className="text-4xl font-bold text-purple-800">{toolkit.measurement.weeklyTargets.videos}</p>
              <p className="text-sm text-gray-600">Videos</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="border-2 border-blue-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <TrendingUp className="w-5 h-5 text-blue-700" />
            Required Metrics to Track
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          {metrics.map((metric, idx) => (
            <div key={idx} className="flex items-start gap-3 p-3 bg-white rounded-lg border border-gray-100">
              <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
              <span className="text-gray-700 text-sm">{metric}</span>
            </div>
          ))}
        </CardContent>
      </Card>

      <Card className="border-2 border-amber-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <ClipboardCheck className="w-5 h-5 text-amber-700" />
            Story Quality Checklist
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          {checklist.map((item, idx) => (
            <div key={idx} className="flex items-start gap-3 p-3 bg-white rounded-lg border border-gray-100">
              <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
              <span className="text-gray-700 text-sm">{item}</span>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
};

export default MeasurementSection;
